import { H1, Loading } from "@components";
import { useFetchWorkspaces } from "features/workspaces/hooks/useFetchWorkspaces";
import { Workspace } from "features/workspaces/components/Workspace";
import { useBreadcrumbs } from "@hooks/useBreadcrumbs/useBreadcrumbs";
import { useEffect } from "react";

export const WorkspacesPage = () => {
  const [workspace, isLoading] = useFetchWorkspaces();
  const { setBreadcrumbsMap } = useBreadcrumbs();

  useEffect(() => {
    if (workspace) {
      setBreadcrumbsMap({
        workspaceId: workspace.name,
      });
    }

    return () => setBreadcrumbsMap(null);
  }, [workspace]);

  if (isLoading) {
    return <Loading />;
  }

  if (!workspace) {
    return <H1 label="No workspaces found" />;
  }

  return <Workspace workspace={workspace} />;
};
